<template>
  <div class="my_usercen">
    个人中心，暂未完成
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.my_usercen{

}
</style>